export const YEARLY = 360;
export const MONTHLY = 30;
export const WEEKLY = 7;
